module.exports = __webpack_public_path__ + "img/imgSLOGAN-da.d744f23f.png";